
import Vue from "vue"

import { NoticeOptions } from "$/plugin"
import Notice from "./Notice.vue"

interface IData {
  notices: NoticeOptions[]
}

export default Vue.extend({
  name: "CripNotices",

  components: { Notice },

  props: {
    className: { type: String },
    icons: { type: Object },
    styles: { type: Object },
  },

  data(): IData {
    return {
      notices: [],
    }
  },

  methods: {
    add(notice: NoticeOptions) {
      this.notices.push(notice)
    },

    remove(name: string) {
      this.notices.forEach((notice, index) => {
        if (notice.name !== name) return

        this.notices.splice(index, 1)
      })
    },

    removeAll() {
      this.notices = []
    },
  },
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Notices.vue